export default __webpack_public_path__ + "static/media/scarlett.5f8b3f5b.png";